import { useEffect } from "react";
import { GatekeeperService } from "GatekeeperService";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import { setProfileCompleted } from "store/slice/login-slice";

const Gatekeeper = ({ children }) => {
  const { user_details } = useSelector((state) => state.loginReducer);
  const location = useLocation();
  const dispatch = useDispatch();

  const hasGatePass = location.state?.hasGatePass;

  const { org_type, is_profile_completed } =
    user_details || {};

  const isCorporate = org_type === "corporate";
  const needsPathwayCheck =
    isCorporate && !is_profile_completed;

  const validator = needsPathwayCheck ? "pathway-checker" : location.pathname;

  const routeValidator = hasGatePass ? null : GatekeeperService[validator];

  const validationResult = routeValidator
    ? routeValidator({
        sltdProfile: user_details,
        childProps: children.props,
        pathname: location.pathname,
      })
    : null;

  const completeProfile = validationResult?.completeProfile;

  // every onboarding step is done, so record the profile as complete once the
  // user is sent on to the dashboard
  useEffect(() => {
    if (completeProfile) {
      dispatch(setProfileCompleted({ is_profile_completed: true }));
    }
  }, [completeProfile, dispatch]);

  if (!validationResult || validationResult.isAllowed) {
    return children;
  } else {
    return (
      <Redirect
        to={{
          pathname: validationResult.redirectUrl,
          state: validationResult.state,
        }}
      />
    );
  }
};

export default Gatekeeper;
